import { UserCard } from '@widgets/user';
import type { User } from '@entities/user';

type UserInfoManagerProps = {
  user: User;
  editLink: string;
};

export const UserInfoManager = ({ user, editLink }: UserInfoManagerProps) => {
  return (
    <UserCard
      isEdit
      editLink={editLink}
      firstName={user.profile.firstName}
      lastName={user.profile.lastName}
      email={user.email}
      group={user.role.name}
      company={user?.company?.name}
      phone={user.profile.phone}
    />
  );
};
